import React from 'react';
import * as styles from './index.module.less';
import { PublicCheckFilled } from 'notta-web-icon';
import RightTag from '@/modules/pricing-v2/right-tag';

interface ICardPlanRight {
  title: string;
  rightList: {
    new?: boolean;
    beta?: boolean;
    text: string;
  }[];
  index: number;
}

const CardPlanRight = ({ title, rightList, index }: ICardPlanRight) => {
  return (
    <div
      style={{
        gridArea: `r${index}`,
      }}
      className={styles.plan_right_wrapper}
    >
      <div className={styles.plan_right_title}>{title}</div>
      <div className={styles.plan_right_list}>
        {rightList.map((item) => {
          return (
            <div key={item.text} className={styles.right_item}>
              <PublicCheckFilled />
              <div className={styles.right_item_text}>{item.text}</div>
              {item?.beta && <RightTag className={styles.right_tag} type="beta" />}
              {item?.new && <RightTag className={styles.right_tag} type="feature" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default CardPlanRight;
